export default "__VITE_ASSET__BCCcPSmw__"